(function () {
  const KEYWORDS = ['consigne', 'deposit', 'canteen'];

  function containsKeyword(text) {
    const t = (text || '').toLowerCase();
    return KEYWORDS.some(k => t.includes(k));
  }

  function hideClosestOption(el) {
    // Try common wrappers for variant/option UI
    const wrapper =
      el.closest('[role="radio"]') ||
      el.closest('label') ||
      el.closest('li') ||
      el.closest('fieldset') ||
      el.closest('.variant-picker') ||
      el.closest('.product-card__content') ||
      el.closest('.product-grid__card') ||
      el.closest('div');

    if (wrapper) wrapper.style.display = 'none';
  }

  function run() {
    document.querySelectorAll('.product-recommendations').forEach((container) => {
      // 1) Hide by input attributes if reachable
      container.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach((input) => {
        const aria = (input.getAttribute('aria-label') || '').toLowerCase();
        const val = (input.value || '').toLowerCase();
        if (containsKeyword(aria) || containsKeyword(val)) {
          input.style.display = 'none';
          const label = input.closest('label') || container.querySelector(`label[for="${input.id}"]`);
          if (label) label.style.display = 'none';
        }
      });

      // 2) Hide by visible text (works even if no inputs are selectable)
      const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          if (!node.nodeValue) return NodeFilter.FILTER_REJECT;
          if (containsKeyword(node.nodeValue)) return NodeFilter.FILTER_ACCEPT;
          return NodeFilter.FILTER_REJECT;
        }
      });

      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);

      nodes.forEach((textNode) => {
        const el = textNode.parentElement;
        if (!el) return;

        // Avoid nuking the whole recommendations section: only hide the smallest “option-like” container
        hideClosestOption(el);
      });
    });
  }

  // Run now, then again after load, then a few times (in case of late injection)
  run();
  window.addEventListener('load', run);
  setTimeout(run, 300);
  setTimeout(run, 1200);
  setTimeout(run, 2500);

  // Observe DOM changes for ongoing injections
  const observer = new MutationObserver(run);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
